import { useForm } from "react-hook-form";
import Loader from "react-loader-spinner";
import momentJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import { useHistory } from "react-router-dom";
import { setUserPop } from "../store/api/Users";
import { Button, Card, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setCustomerPopup } from "../store/api/Modals";
import ModalSelectUser from "../Components/ModalSelectUser";
import { useEffect, useRef, useState } from "react";
import ModalSelectCustomer from "../Common/ModalSelectCustomer";
import { exportToExcel } from "../../store/api/CommonFunctions";
import { loadDocumentTypes } from "../store/api/CommonFunctions";
import { loadEventsHistory, getEventTypeList } from "../store/api/CustomerApi";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, FileEarmarkPerson, List, Printer, Search } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBroom } from "@fortawesome/free-solid-svg-icons";
import ModalSelectCategory from "../Components/Customer/ModalSelectCategory";

const EventsHistory = () => {

    const currPage = useRef(1);
    const totalPage = useRef(0);
    const history = useHistory();
    const searchData = useRef({});
    const dispatch = useDispatch();
    const frmFilters = useRef();
    const { register, handleSubmit } = useForm();
    const [pending, setPending] = useState(false);
    const [documentTypes, setDocTypes] = useState([]);
    const [showFilters, setShowFilters] = useState(true);
    const [selectedUserNames, selectUser] = useState(null);
    const [selectedCustomerNames, selectCustomer] = useState(null);
    const [modalCategories, setModalCategories] = useState({ show: false });
    const [selectedCategory, setSelectedCategory] = useState(null);
    const { list, typeList, filters } = useSelector(state => {
        return {
            list: state.customerDataReducer.eventsHistory,
            typeList: state.customerDataReducer.eventTypeList,
            filters: state.customerDataReducer.eventsHistoryFilters
        }
    });
    const totalCount = list && list.TotalCount ? Number(list.TotalCount) : 0;
    const take = Number(filters.Take ?? 0);
    if (totalPage.current < 1 && take > 0) {
        totalPage.current = Math.floor(totalCount / take) + ((totalCount % take) > 0 ? 1 : 0);
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber" },
        { colTitle: "تاریخ رویداد", colName: "PCreationDate", showInMobile: true },
        { colTitle: "شرح رویداد", colName: "Description", showInMobile: true, maxTextLength: 70, colType: "string", hasTooltip: true, style: { maxWidth: "350px" } },
        { colTitle: "نام مشتری/بالقوه", colName: "CustomerName", maxTextLength: 50, colType: "string" },
        { colTitle: "مشتری/بالقوه", colName: "CustomerType", maxTextLength: 50, colType: "string" },
        { colTitle: "نوع فعالیت", colName: "PAttachmentType" },
        { colTitle: "نوع رویداد", colName: "EventTypeName" },
        { colTitle: "دسته بندی", colName: "CategoryCode+CategoryName", colType: "string" },
        { colTitle: "تاریخ پیگیری", colName: "PNextDate" },
        { colTitle: "ثبت کننده", colName: "CreateByName" },
        // { colTitle: "جزئیات بیشتر", colName: "MoreDetails", showInMobile: false, maxTextLength: 32, colType: "string", hasTooltip: true, style: { maxWidth: "180px" } },
        { colTitle: "وضعیت مشتری", colName: "CustomerStatus" }
    ]
    const tableRowButtons = [
        {
            title: "پرونده مشتری/بالقوه", type: "common", icon: <FileEarmarkPerson className="rowBtn" size={19} color="#654ad3" />,
            className: "group-Btn-smalll", onclick: (item) => {
                if (item.CustomerType === "مشتری بالقوه") {
                    history.push("/CRM/AddEditPreCustomer/" + item.CustomerID);
                }
                else {
                    history.push("/CRM/AddEditCustomer/" + item.CustomerID);
                }
            }
        }

    ]
    const search = (data) => {
        currPage.current = 1;
        totalPage.current = 0;
        data.Skip = 0;
        //data.Take = 10;
        if (!searchData.current.CreateByIds && filters.CreateByIds) {
            searchData.current.CreateByIds = [...filters.CreateByIds];
        }
        if (!searchData.current.CustomerIDs && filters.CustomerIDs) {
            searchData.current.CustomerIDs = [...filters.CustomerIDs];
        }
        const filterData = { ...data, ...searchData.current };
        filterData.PDateFrom = document.getElementsByName("DateFrom")[0]?.value;
        if (!filterData.PDateFrom || filterData.PDateFrom === "") {
            filterData.DateFrom = null;
        }
        filterData.PDateTo = document.getElementsByName("DateTo")[0]?.value;
        if (!filterData.PDateTo || filterData.PDateTo === "") {
            filterData.DateTo = null;
        }
        dispatch(loadEventsHistory(filterData));
    }
    function toExcel() {
        const url = "api/CustomersAPI/LoadEventsHistory";
        const searchArgs = { ...filters };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("EventHistory", searchArgs, url, "post", tableColes, () => setPending(false));
    }
    function print(e) {
        history.push({
            pathname: `/PrintViewer/EventHistory/${e.ctrlKey}`,
            state: {
                dataUrl: "api/CustomersAPI/LoadEventsHistory",
                method: "post",
                fetchBody: JSON.stringify({ ...filters, Take: 0, Skip: 0 })
            }
        });
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilters(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilters(true);
        }
    }
    const showUserPOP = (e) => {
        if (e.key && e.key === "Enter") {
            return;
        }
        const selectUsersWithName = (list) => {
            if (!list) {
                searchData.current.CreateByIds = [];
                selectUser(" ");
                return;
            }
            searchData.current.CreateByIds = list.map(l => l.ID);
            const userNames = list.map(l => l.Name).join("،");
            selectUser(userNames);
        }
        dispatch(setUserPop({ show: true, selectUsersWithName: selectUsersWithName }));
    }
    const showCustomerPop = (e) => {
        if (e.key && e.key === "Enter") {
            return;
        }
        const onSelectCust = (type, list) => {
            if (!list) {
                searchData.current.CustomerIDs = [];
                //searchData.current.IsCustomer = null;
                //searchData.current.IsPreCustomer = null;
                selectCustomer(" ");
                return;
            }
            searchData.current.CustomerIDs = list.map(l => l.ID);
            searchData.current.IsCustomer = type === "customer";
            searchData.current.IsPreCustomer = type === "precustomer";
            const custNames = list.map(l => l.Name).join("،");
            selectCustomer(custNames);
        }
        dispatch(setCustomerPopup({ show: true, onSelectWithNames: onSelectCust }));
    }
    function clearFilters() {
        frmFilters.current.reset();
        searchData.current.CreateByIds = [];
        searchData.current.CustomerIDs = [];
        searchData.current.DateFrom = null;
        searchData.current.DateTo = null;
        selectCustomer(" ");
        selectUser(" ");
        dispatch(loadEventsHistory({ Take: 10, Skip: 0 }));
    }
    const showModalCategory = () => {
        setModalCategories({
            show: true,
            setSelectedCategory: setSelectedCategory
        })
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        dispatch(getEventTypeList());
        loadDocumentTypes(setDocTypes);
    }, [])
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle">تاریخچه رویدادها</Card.Header>
                <Card.Body className="card-body bodyStyle" style={{ textAlign: "right", position: "relative" }}>
                    <ModalSelectUser />
                    <ModalSelectCustomer />
                    <ModalSelectCategory modalData={modalCategories} setModalData={setModalCategories} />
                    <form onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilters && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilters && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilters && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <div className="row" >
                                <div className="col-md-2 form-group">
                                    <label>نوع رویداد</label>
                                    {typeList === "PENDING" &&
                                        <div className="search-input"><Loader type="BallTriangle" width={25} height={25} color="#bb1370" /></div>
                                    }
                                    {typeList && Array.isArray(typeList) &&
                                        <select className="search-input" name="EventTypeID" ref={register({})} defaultValue={filters?.EventTypeID ?? ""} >
                                            <option value="">انتخاب کنید</option>
                                            {
                                                typeList.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                                        </select>
                                    }
                                </div>
                                <div className="col-md-2 form-group">
                                    <label>دسته بندی رویداد</label>
                                    <input type="hidden" readOnly value={selectedCategory?.id ?? ""} name="CategoryID" ref={register({})} defaultValue={filters?.CategoryID ?? ""} />
                                    <input className="search-input" readOnly value={selectedCategory?.name ?? ""} name="CategoryName" ref={register({})} defaultValue={filters?.CategoryName ?? ""} />
                                    <Button className="btn-input-tiny" onClick={showModalCategory} style={{ top: 22 }}><List size={17} /></Button>
                                </div>
                                <div className="col-md-2 form-group">
                                    <label>نوع فعالیت</label>
                                    {documentTypes === "PENDING" &&
                                        <div className="search-input"><Loader type="BallTriangle" width={20} height={20} color="#bb1370" /></div>
                                    }
                                    {documentTypes && Array.isArray(documentTypes) &&
                                        <select className="search-input scThin" name="AttachmentType" ref={register({})} defaultValue={filters?.AttachmentType ?? ""}>
                                            <option value="">انتخاب کنید</option>
                                            {
                                                documentTypes.map((item, i) => <option key={i} value={item.DocumentHard_Code}>{item.DocumentName}</option>)
                                            }
                                        </select>}
                                </div>
                                <div className="col-md-2 form-group">
                                    <label>از تاریخ</label>
                                    <DatePicker isGregorian={false} timePicker={false} className="search-input" name='DateFrom'
                                        value={filters?.DateFrom ? momentJalaali(filters.DateFrom) : searchData.current.DateFrom ? momentJalaali(searchData.current.DateFrom) : null}
                                        onChange={value => { searchData.current.DateFrom = value.local("en").format("YYYY-MM-DD") }} />
                                </div>
                                <div className="col-md-2 form-group">
                                    <label>تا تاریخ</label>
                                    <DatePicker isGregorian={false} timePicker={false} className="search-input" name='DateTo'
                                        value={filters && filters.DateTo ? momentJalaali(filters.DateTo) : searchData.current.DateTo ? momentJalaali(searchData.current.DateTo) : null}
                                        onChange={value => { searchData.current.DateTo = value.local("en").format("YYYY-MM-DD") }} />
                                </div>
                                <div className="col-md-2 form-group">
                                    <label style={{ display: "block" }}>شرح رویداد</label>
                                    <input type="text" className="search-input" name="Description" ref={register({})} defaultValue={filters?.Description ?? ""} />
                                </div>
                                <div className="col-md-2 form-group">
                                    <label style={{ display: "block" }}>جزئیات بیشتر</label>
                                    <input type="text" className="search-input" name="MoreDetails" ref={register({})} defaultValue={filters?.MoreDetails ?? ""} />
                                </div>
                                <div className="col-md-2 form-group">
                                    <label style={{ display: "block" }}>مشتری/بالقوه</label>
                                    <input type="text" className="search-input" name="SelectedCustomerNames" ref={register({})} readOnly onKeyDown={showCustomerPop}
                                        value={selectedCustomerNames ? selectedCustomerNames : filters?.SelectedCustomerNames ? filters.SelectedCustomerNames : ""} />
                                    <Button className="btn-input-tiny" onClick={showCustomerPop} style={{ top: 22 }}><List size={18} /></Button>
                                </div>
                                <div className="col-md-2 form-group">
                                    <label style={{ display: "block" }}>ثبت کننده</label>
                                    <input type="text" className="search-input" name="SelectedUserNames" ref={register({})} readOnly onKeyDown={showUserPOP}
                                        value={selectedUserNames ? selectedUserNames : filters?.SelectedUserNames ? filters.SelectedUserNames : ""} />
                                    <Button className="btn-input-tiny" onClick={showUserPOP} style={{ top: 22 }}><List size={18} /></Button>
                                </div>
                                <div className="col-md-2 form-group">
                                    <label style={{ display: "block" }}>مرتب سازی براساس</label>
                                    <select className="search-input" name="SortBy" ref={register({})} defaultValue={filters?.SortBy ?? ""}>
                                        <option value="">انتخاب کنید</option>
                                        <option value="CreationDate">تاریخ - صعودی</option>
                                        <option value="CustomerName">نام مشتری - صعودی</option>
                                        <option value="CustomerName Desc">نام مشتری - نزولی</option>
                                        <option value="Status">وضعیت - صعودی</option>
                                        <option value="Status Desc">وضعیت - نزولی</option>
                                    </select>
                                </div>
                                <div className="col-md-2 form-group">
                                    <label style={{ display: "block" }}>تعداد در صفحه</label>
                                    <select className="search-input" name="Take" ref={register({})} defaultValue={filters?.Take ?? 10}>
                                        <option value={0}>انتخاب کنید</option>
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={15}>15</option>
                                        <option value={20}>20</option>
                                    </select>
                                </div>
                                <div className="col-md-4 form-group" style={{ maxWidth:"max-content" }}>
                                    <div style={{ border: "1px solid gray", borderRadius: "3px", padding: "7px" }}>
                                        <input type="checkbox" className="form-check-input" name="IsCustomer" ref={register({})} defaultChecked={filters?.IsCustomer ?? true} />
                                        &nbsp;
                                        <label>مشتری</label>
                                        &nbsp;&nbsp;
                                        <input type="checkbox" className="form-check-input" name="IsPreCustomer" ref={register({})} defaultChecked={filters?.IsPreCustomer ?? true} />
                                        &nbsp;
                                        <label>مشتری بالقوه</label>
                                        &nbsp;&nbsp;
                                        <input type="checkbox" className="form-check-input" name="JustLastEvent" ref={register({})} defaultChecked={filters?.JustLastEvent ?? false} />
                                        &nbsp;
                                        <label style={{ marginTop: "2px" }}>رویداد آخر هر مشتری</label>
                                    </div>
                                </div>                                
                            </div>
                        </Row>

                        <Button type="submit" variant="secondary" className="group-Btn mt-1"><Search />&nbsp;جستجوی رویداد</Button>
                    </form>
                    {!pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}>
                        <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        <Printer onClick={print} size={25} color="blue" style={{ cursor: "pointer" }} className="hoverIcon" />
                    </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable hasPaging={true} rowButtons={tableRowButtons} columns={tableColes} filterData={filters} searchMethod={(data) => dispatch(loadEventsHistory(data))} reducerName="customerDataReducer" objectName="eventsHistory" />
                </Card.Body>
            </Card>
        </div>
    )
}
export default EventsHistory;